import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import MainNavBar from "./navbar";
import ChangePassword from "./change-password";
import TimePicker from "./time-picker";
import ConfirmationDialog from "./confirmation-dialog";
import DepartmentList from "../senzgauge/machines/department-list";
import ToggleButtons from "../layouts/toggle-button";
import MachineList from "../senzgauge/machines/machine-list";
import ReportList from "../senzgauge/machines/report-list";
import MachinePerformanceGraph from "../senzgauge/machines/machine-performance-graph";
import MachinePerformanceTable from "../senzgauge/machines/machine-performance-table";
import EmployeeReportHome from "../senzgauge/machines/employee-report-home";
import EmployeeReport from "../senzgauge/machines/employee-report";
import ManualDataEntry from "../senzgauge/machines/manual-data-entry";
import JobDetailsEntry from "../senzgauge/machines/job-details-entry";


const   MainLayout = () => {

  return (
    <div className={"h-100pe"}>
      <header>
        <MainNavBar/>
        <ToggleButtons/>
        <ChangePassword/>
        <TimePicker/>
        <ConfirmationDialog/>
      </header>
      <Switch>
        <Route path="/home" component={DepartmentList}/>
          <Route path="/:departmentID/:machineID/:performance/performanceTable" component={MachinePerformanceTable}/>
          <Route path="/:departmentID/:machineID/:performance/performanceGraph" component={MachinePerformanceGraph}/>
          <Route path="/:departmentID/:machineID/report" component={ReportList}/>
          <Route path="/:departmentID/machine/" component={MachineList}/>
          <Route path="/employee" component={EmployeeReportHome} />
          <Route path="/employeeReport/:employeeID" component={EmployeeReport} />
          <Redirect from="/employeeReport" to="/employee"/>
          <Route path="/manualEntry" component={ManualDataEntry}/>
          <Route path="/jobDetails" component={JobDetailsEntry}/>
          <Redirect exact from='/' to='/home'/>
      </Switch>
    </div>
  );
};

export default MainLayout;
